/* eslint-disable react/prop-types */
/* eslint-disable  react/no-array-index-key */
/* eslint-disable  jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Modal } from 'react-bootstrap';
import AppLink from '../../shared/components/app-link/AppLink';
import { formatCurrency } from '../../shared/helper-utils/appUtils';
import AppButton from '../../shared/components/app-button/AppButton';

export default function BaggageSelectionComponent({
  showBaggage,
  setShowBaggage,
  flightLegsWithBaggageRef,
  baggageSelectionSector,
  setBaggageSelectionSector,
  userSelectedSsrRows,
  travellers,
  activeBagIndex,
  setActiveBagIndex,
  getSelectedBaggage,
  handleTermsConditions,
  handleRemoveBaggage,
  handleAddBaggage,
  isNormalBooking = true,
}) {
  const getByName = (userBaggageRows) => {
    return userBaggageRows.reduce((acc, cur) => {
      if (acc[cur.fullName]) {
        acc[cur.fullName].push(cur);
      } else {
        acc[cur.fullName] = [cur];
      }
      return acc;
    }, {});
  };
  return (
    <Modal
      className="app-modal meal-modal"
      show={showBaggage}
      onHide={() => setShowBaggage(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Baggage</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="separator" />
        <div className="baggage-sectors-row d-flex">
          {Object.keys(flightLegsWithBaggageRef).map((sector) => (
            <div
              key={sector}
              className={`baggage-sector ${
                baggageSelectionSector === sector ? 'active-baggage-sector' : ''
              }`}
              onClick={() => setBaggageSelectionSector(sector)}
            >
              {sector}
            </div>
          ))}
        </div>
        <div className="separator" />
        {Object.keys(flightLegsWithBaggageRef).length === 0 && (
          <div className="p-3">Baggage is not available.</div>
        )}
        {Object.keys(flightLegsWithBaggageRef).map((sector) => {
          const baggageList = flightLegsWithBaggageRef[sector];
          const userBaggageRows = userSelectedSsrRows[sector].baggageRows;
          let byName;
          if (!isNormalBooking) {
            byName = getByName(userBaggageRows);
          }
          return (
            baggageSelectionSector === sector && (
              <div key={sector}>
                <div className="d-flex p-3 travellers-info">
                  {isNormalBooking ? (
                    <>
                      {travellers.map(
                        (traveller, index) =>
                          traveller.type.toLowerCase() !== 'infant' && (
                            <div
                              className={`traveller-name ${
                                activeBagIndex === index && 'active-traveller'
                              }`}
                              key={index}
                              onClick={() => setActiveBagIndex(index)}
                            >
                              {traveller.first_name !== ''
                                ? `${traveller.title} ${traveller.first_name} ${traveller.last_name}`
                                : `Traveller ${index + 1}`}
                              <small className="traveller-name__subheading">
                                {getSelectedBaggage(userBaggageRows, index)}
                              </small>
                            </div>
                          ),
                      )}
                    </>
                  ) : (
                    <>
                      {Object.keys(byName).map(
                        (fullName, index) =>
                          byName[fullName][0].paxtype.toLowerCase() !==
                            'infant' && (
                            <div
                              className={`traveller-name ${
                                activeBagIndex === index && 'active-traveller'
                              }`}
                              key={index}
                              onClick={() => setActiveBagIndex(index)}
                            >
                              {fullName}
                              <small className="traveller-name__subheading">
                                {getSelectedBaggage(
                                  byName[fullName],
                                  index,
                                  sector,
                                )}
                              </small>
                            </div>
                          ),
                      )}
                    </>
                  )}
                </div>
                <div className="separator" />
                <div className="d-flex flex-wrap justify-content-between p-3">
                  {baggageList.map((baggage, index) => (
                    <div
                      key={`${baggage.ssrcode}_${index}`}
                      className="ssr-card p-2 mb-2"
                    >
                      <div>
                        <img
                          className="meal-image"
                          src={baggage.imageurl}
                          alt={baggage.ssrname}
                        />
                      </div>
                      <div className="ps-3 pe-3 w-100 d-flex flex-column">
                        <div className="flex-1">
                          <p className="ssr-card__meal-name">
                            {baggage.ssrname}
                          </p>
                          <p className="ssr-card__meal-description">
                            {baggage.Desc === 'internationalconnections' ? (
                              <div>
                                <span>
                                  This baggage is valid only for international
                                  connections.
                                </span>
                                <AppLink
                                  linkText="Terms and conditions"
                                  isLink={false}
                                  onClick={handleTermsConditions}
                                />
                              </div>
                            ) : (
                              baggage.Desc
                            )}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="ssr-card__meal-name">
                            {formatCurrency(baggage.chargeableamount)}
                          </p>
                          {userBaggageRows[activeBagIndex].hasSsr ? (
                            ''
                          ) : (
                            <>
                              {userBaggageRows[activeBagIndex].ssrcode ===
                              baggage.ssrcode ? (
                                <AppButton
                                  variant="outlined"
                                  className="ssr-card__add-btn"
                                  btnText="Remove"
                                  onClick={() =>
                                    handleRemoveBaggage(
                                      baggage,
                                      activeBagIndex,
                                      sector,
                                    )
                                  }
                                />
                              ) : (
                                <AppButton
                                  className="ssr-card__add-btn"
                                  btnText="Add"
                                  onClick={() =>
                                    handleAddBaggage(baggage, sector)
                                  }
                                />
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )
          );
        })}
      </Modal.Body>
      <Modal.Footer>
        <AppButton
          onClick={() => setShowBaggage(false)}
          btnText="Continue"
          variant="outlined"
        />
      </Modal.Footer>
    </Modal>
  );
}
